import { Button } from '../button'
import { useFormContext } from './form-context'

export default function FormSubmitButton({ disabled, loading, ...props }: FormSubmitButton.Props) {
  const form = useFormContext()
  return (
    <form.Subscribe
      selector={(state) => ({ canSubmit: state.canSubmit, isSubmitting: state.isSubmitting })}
    >
      {({ canSubmit, isSubmitting }) => (
        <Button
          disabled={!canSubmit || disabled}
          loading={isSubmitting || loading}
          type="submit"
          {...props}
        />
      )}
    </form.Subscribe>
  )
}

export namespace FormSubmitButton {
  export interface Props extends Button.Props {}
}
